import React, { useEffect, useState } from "react";
import { useConfigsQuery } from "./components/queries.js";
import './Offers.css';
import "./Global.js";

const strapiServerUrl = window.strapiServerUrl;

const Offers = () => {
    const { loading, error, data } = useConfigsQuery();
    const [offers,setOffers] = useState([]);

    useEffect(() => {
        if (data) {
          const contentData = data.offers.data;
          const currentDate = new Date();

          // Filter offers based on start_date and end_date
          const activeOffers = contentData.filter((offer) => {
            const startDate = new Date(offer.attributes.start_date);
            const endDate = new Date(offer.attributes.end_date);
            return startDate <= currentDate && endDate >= currentDate;
          });
          setOffers(activeOffers);
        }
      }, [data]);


    return ( 
        <div className="offers-container">
             {loading ? (
            <div className="center">Loading...</div>
          ) : error ? (
            <div>Error: {error.message}</div>
          ) : ( offers.length !== 0 && (
            offers.map((offer,index) => (
        <div className="grid-item" key={index}>
          <a href={offer.attributes.destination_link}>
            <img src={offer.attributes.banner_image.data && `${strapiServerUrl}${offer.attributes.banner_image.data.attributes.url}`} alt={offer.name} />
            <div className={offer.attributes.hover_text ? 'hover-text' : ''}>{offer.attributes.hover_text && offer.attributes.hover_text}</div>
          </a>
        </div>
      ))
    ))}
        </div>
     );
}
 
export default Offers;